import BootstrapTable from 'react-bootstrap-table-next';
import React from 'react';
import { Button, Col, Dropdown, Row } from 'react-bootstrap'
import { connect } from "react-redux";
import checkJwt from './../../../../Global/jwtChecker'
import logout from './../../../../Global/logout'
import { BsBackspaceFill } from 'react-icons/bs'
import { withNamespaces } from 'react-i18next';
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import paginationFactory from 'react-bootstrap-table2-paginator';
import { isMobile } from "react-device-detect";
import cellEditFactory from 'react-bootstrap-table2-editor';
import axios from 'axios';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import Loader from '../../../../Global/loader';

export class ReportErrorList extends React.Component{
  constructor(props) {
    super(props)

    //this.CorrectErrors = this.CorrectErrors.bind(this);

    this.state={
        loading: false,
        uploadingReport: false,
        percentage: 0,
        themeColor: "test",
        pathColor: "#000",
        correctErrors: false,
        errorsExist: false,
        allSelected: false,
        listForSend: [],
        successes: 0,
        errors: 0,


        stupci:[
            { name: "ID KORISNIKA", value: "customer_id" },
            { name: "INDETIFIKATOR NARUDŽBE", value: "transaction_id" },
            { name: "DATUM I VRIJEME NARUDŽBE", value: "transaction_date" },
            { name: "NAČIN PLAĆANJA", value: "payment_type" },
            { name: "DRŽAVA", value: "country" },
            { name: "OZNAKA DRŽAVE", value: "country_code" },
            { name: "E - MAIL", value: "e-mail" },
            { name: "STVARNA CIJENA", value: "amount" },
            { name: "IME I PREZIME", value: "customer_name" },
            { name: "STVARNA CIJENA VALUTA", value: "currency" },
            { name: "PAKET", value: "item_name" },
            { name: "ŠIFRA", value: "item_code" },
            { name: "KOLIČINA", value: "tem_quantity" }
        ]
    }
}

    componentDidMount = async () => {
        this.props.mapState("MAP_LOADING_CLIENT", true)

        if(this.props.reportErrorList.length > 0 ){
            this.setState({ errorsExist: true, allSelected: false})
            this.props.mapState("MAP_REPORTS_SIZE_PER_PAGE",10)
            this.props.mapState("MAP_REPORTS_ACTIVE_PAGE", 1)
        }

        const unHashedJwt = await checkJwt()

        if(!unHashedJwt){
            logout()
        }

        this.props.mapState("MAP_LOADING_CLIENT", false)
    }

    handlePageChange(pageNumber) {
		this.props.mapState("MAP_CLIENT_LIST_ACTIVE_PAGE", pageNumber)
    }

    handleItemsPerPageChange(itemsPerPage) {
		this.setState({itemsPerPage: itemsPerPage});
        this.props.mapState("MAP_REPORTS_SIZE_PER_PAGE", itemsPerPage)
    }

    showModal = uuid => {
        this.setState({
            showModal: !this.state.showModal,
            uuidForDelete: uuid
        });
    };

    checkboxToggle = async (row) => {
        let indexForMapping

        await this.props.reportErrorList.map((data, index) => {
            if( data["ID KORISNIKA"] === row["ID KORISNIKA"] && data["INDENTIFIKATOR NARUDŽBE"] === row["INDENTIFIKATOR NARUDŽBE"]){
                indexForMapping = index
            }
            return null
        })

        let data = {
            index: indexForMapping,
            variable: "selected",
            value: !row.selected
        }

        this.props.mapState("MAP_REPORTS_ERROR_LIST_CHANGE", data)
    }

    checkboxToggleAll = async () => {
        let i = 0;
        let kraj = 0;

        if(this.props.activePage !== 1){
            i = this.props.activePage - 1
        }
        else{
            i = 0;
        }

        kraj = i + this.props.sizePerPage

        for(i; i < kraj ; i++){

            let dataRedux = {
                index: i,
                variable: "selected",
                value: !this.state.allSelected
            }
            this.props.mapState("MAP_REPORTS_ERROR_LIST_CHANGE", dataRedux)
        }

        await this.setState({allSelected: !this.state.allSelected})
    }

    CorrectedErrors = async () => {
        await this.setState({
            uploadingReport : true
        })
        const unHashedJwt = await checkJwt()
        let i = 0;
        var self = this;
        let duljina = this.props.reportErrorList.length;

        let privremenaLista = this.props.reportErrorList
        for(i; i < duljina ; i++){
            let brojac = i
            let data = privremenaLista[i]

            if(data.Error === false && data.selected){
                var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
                var localISOTime = (new Date(Date.now() - tzoffset)).toISOString()

                await axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/user/transactions', {
                    method: 'post',
                    headers: { 'Authorization' : unHashedJwt},
                    data: {
                        "transaction_type": 2,
                        "transaction_id": data["INDETIFIKATOR NARUDŽBE"],
                        "transaction_date": data["DATUM I VRIJEME NARUDŽBE"],
                        "payment_type": data["NAČIN PLAĆANJA"],
                        "country": data["DRŽAVA"],
                        "country_code": data["OZNAKA DRŽAVE"],
                        "processed_date": localISOTime,
                        "e-mail": data["E - MAIL"],
                        "customer_name": data["IME I PREZIME"],
                        "customer_id": data["ID KORISNIKA"],
                        "amount": data["STVARNA CIJENA"],
                        "currency": data["STVARNA CIJENA VALUTA"],
                        "item_name": data["PAKET"],
                        "item_code": data["ŠIFRA"],
                        "item_quantity": data["KOLIČINA"],
                        "transaction_log": JSON.stringify(data)
                    }
                }).then(res => {
                    let postotak =  Math.round(((brojac+1)/ this.props.reportErrorList.length) * 100)
                    self.setState({successes: self.successes + 1})
                    //this.mapState({ successes: this.state.successes + 1})
                    this.props.mapState("MAP_REPORTS_UPLOAD_PERCENTAGE", postotak)
                    this.props.mapState("MAP_REPORTS_ERROR_LIST_SUCCESS", data["INDETIFIKATOR NARUDŽBE"])
                })
                .catch(error => {
                    if(error.response.data.status === 401){
                        logout()
                    }
                    let postotak =  Math.round(((brojac+1)/ this.props.reportErrorList.length) * 100)
                    let greska = error.response.data.message.split(" ")
                    data["Error"] = greska[0]
                    self.setState({errors: self.errors + 1})
                    //this.mapState({errors: this.state.errors + 1})
                    //this.props.mapState("MAP_REPORTS_ERROR", errors)
                    //this.props.mapState("MAP_REPORTS_ERROR_LIST", data)
                    this.props.mapState("MAP_REPORTS_UPLOAD_PERCENTAGE", postotak)

                    let dataError = {
                        index: brojac,
                        variable: "Error",
                        value: greska[0]
                    }

                    this.props.mapState("MAP_REPORTS_ERROR_LIST_CHANGE", dataError)
                })

            }
        }

        if(this.props.reportErrorList.length === 0){
            this.setState({ errorsExist: false})
        }

        await this.setState({
            uploadingReport : false,
            percentage: 0
        })

        await this.props.mapState("MAP_REPORTS_ERROR", 0)
        await this.props.mapState("MAP_REPORTS_UPLOAD_PERCENTAGE", 0)
    }

    onPageChange =({
        page
    }) =>  {
        this.props.mapState("MAP_REPORTS_ACTIVE_PAGE",page)
    }

    render(){
        const {
            themeColor,
            pathColor
        } = this.state;

        const { t } = this.props;

        const columns = [ {
            dataField: 'ID KORISNIKA',
            text: t('ID KORISNIKA'),
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '80px', textAlign: 'center', wordWrap:  "break-word" };
            }
        }, {
            dataField: 'INDETIFIKATOR NARUDŽBE',
            text: t('INDETIFIKATOR NARUDŽBE'),
            editable:false,
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '200px', textAlign: 'center', wordWrap:  "break-word" };
            },
            editCellStyle: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "transaction_id" ? 'red' : '#00FFFF';
                return { backgroundColor };
              },
            style: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "transaction_id" ? 'red' : '#fff';

                const color = row.Error === "transaction_id" ? 'white' : 'black';
                const wordWrap =  "break-word"
                return { backgroundColor, color, wordWrap };
            }
        },{
            dataField: 'NAČIN PLAĆANJA',
            text: t('NAČIN PLAĆANJA'),
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '80px', textAlign: 'center', wordWrap:  "break-word" };
            },
            editCellStyle: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "payment_type" ? 'red' : '#00FFFF';
                return { backgroundColor };
              },
            style: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "payment_type" ? 'red' : '#fff';

                const color = row.Error === "payment_type" ? 'white' : 'black';
                const wordWrap =  "break-word"
                return { backgroundColor, color, wordWrap };
            }
        },{
            dataField: 'DRŽAVA',
            text: t('DRŽAVA'),
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '80px', textAlign: 'center', wordWrap:  "break-word" };
            },
            editCellStyle: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "country" ? 'red' : '#00FFFF';
                return { backgroundColor };
              },
            style: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "country" ? 'red' : '#fff';

                const color = row.Error === "country" ? 'white' : 'black';
                const wordWrap =  "break-word"
                return { backgroundColor, color, wordWrap };
            }
        }, {
            dataField: 'OZNAKA DRŽAVE',
            text: t('OZNAKA DRŽAVE'),
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '80px', textAlign: 'center', wordWrap:  "break-word" };
            },
            editCellStyle: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "country_code" ? 'red' : '#00FFFF';
                return { backgroundColor };
              },
            style: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "country_code" ? 'red' : '#fff';

                const color = row.Error === "country_code" ? 'white' : 'black';
                const wordWrap =  "break-word"
                return { backgroundColor, color, wordWrap };
            }
        },{
            dataField: 'IME I PREZIME',
            text: t('IME I PREZIME'),
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '80px', textAlign: 'center', wordWrap:  "break-word"};
            },
            editCellStyle: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "customer_name" ? 'red' : '#00FFFF';
                return { backgroundColor };
              },
            style: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "customer_name" ? 'red' : '#fff';

                const color = row.Error === "customer_name" ? 'white' : 'black';
                const wordWrap =  "break-word"
                return { backgroundColor, color, wordWrap };
            }
        },{
            dataField: 'PAKET',
            text: t('PAKET'),
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '80px', textAlign: 'center', wordWrap:  "break-word"};
            },
            editCellStyle: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "item_name" ? 'red' : '#00FFFF';
                return { backgroundColor };
              },
            style: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "item_name" ? 'red' : '#fff';

                const color = row.Error === "item_name" ? 'white' : 'black';
                const wordWrap =  "break-word"
                return { backgroundColor, color, wordWrap };
            }
        },{
            dataField: 'E - MAIL',
            text: t('E - MAIL'),
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '80px', textAlign: 'center', wordWrap:  "break-word" };
            },
            editCellStyle: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "e-mail" ? 'red' : '#00FFFF';
                return { backgroundColor };
              },
            style: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "e-mail" ? 'red' : '#fff';

                const color = row.Error === "e-mail" ? 'white' : 'black';
                const wordWrap =  "break-word"
                return { backgroundColor, color, wordWrap };
            }
        }, {
            dataField: 'STVARNA CIJENA',
            text: t('STVARNA CIJENA'),
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '80px', textAlign: 'center', wordWrap:  "break-word"};
            },
            validator: (newValue, row, column) => {
                if (isNaN(newValue)) {
                  return {
                    valid: false,
                    message: t('Price should be numeric')
                  };
                }
                if (newValue <= 0) {
                  return {
                    valid: false,
                    message: t('Price should bigger than 0')
                  };
                }
                return true;
            },
            editCellStyle: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "amount" ? 'red' : '#00FFFF';
                return { backgroundColor };
            },
            style: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "amount" ? 'red' : '#fff';

                const color = row.Error === "amount" ? 'white' : 'black';
                const textAlign = "right";
                const wordWrap =  "break-word"
                return { backgroundColor, color, wordWrap, textAlign };
            },

            formatter: (cellContent, row) => {
                return (
                      <div>
                          <span>{(cellContent)}</span>
                      </div>
                );
            }

        }, {
            dataField: 'STVARNA CIJENA VALUTA',
            text: t('STVARNA CIJENA VALUTA'),
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '80px', textAlign: 'center', wordWrap:  "break-word"};
            },
            editCellStyle: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "currency" ? 'red' : '#00FFFF';
                return { backgroundColor };
            },
            style: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "currency" ? 'red' : '#fff';

                const color = row.Error === "currency" ? 'white' : 'black';
                const textAlign = "right";
                const wordWrap =  "break-word"
                return { backgroundColor, color, wordWrap, textAlign };
            },

            formatter: (cellContent, row) => {
                return (
                      <div>
                          <span>{(cellContent)}</span>
                      </div>
                );
            }

        },{
            dataField: 'ŠIFRA',
            text: t('ŠIFRA'),
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '80px', textAlign: 'center', wordWrap:  "break-word" };
            },
            editCellStyle: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "item_code" ? 'red' : '#00FFFF';
                return { backgroundColor };
              },
            style: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "item_code" ? 'red' : '#fff';

                const color = row.Error === "item_code" ? 'white' : 'black';
                const wordWrap =  "break-word"
                return { backgroundColor, color, wordWrap };
            }
        },{
            dataField: 'KOLIČINA',
            text: t('KOLIČINA'),
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '80px', textAlign: 'center', wordWrap:  "break-word" };
            },
            editCellStyle: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "item_quantity" ? 'red' : '#00FFFF';
                return { backgroundColor };
              },
            style: (cell, row, rowIndex, colIndex) => {
                const backgroundColor = row.Error === "item_quantity" ? 'red' : '#fff';

                const color = row.Error === "item_quantity" ? 'white' : 'black';
                const wordWrap =  "break-word"
                return { backgroundColor, color, wordWrap };
            }
        },
        ]

        /* Custom filter buttons */
        const CustomToggleList = ({ columns, onColumnToggle, toggles}, customFunkcija) => {
            //asiknrona funkcija za poziv default toggler funkcije + sprmenje promjene za poziv prema serveru
            customFunkcija = async (column) => {
                await onColumnToggle(column.dataField)
                /*
                let data = { menu: "client", view: "main" , column: column.dataField }
                await this.props.mapState("USER_MAP_COLUMNS", data)
                /*
                await updateUser(
                    this.props.user,
                    this.props.user.provider_uuid
                )
                */
            }

            if(isMobile){
                return <Dropdown className="sortBy columnTogglerButton float-left w-auto mb-4">
                    <Dropdown.Toggle
                        variant="success"
                        id="dropdown-basic"
                    >
                        {t('Columns')}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                    {columns
                    .filter(data => data.dataField !== "sakriveno")
                    .map(column => ({
                    ...column,
                    toggle: toggles[column.dataField]
                    }))
                    .map((column, index) => (
                            <Dropdown.Item
                                key = {index}
                                type="button"
                                className={ `border-0 ${column.toggle ? 'aktivan' : 'neaktivan'}` }
                                data-toggle="button"
                                label={column.text}
                                id={column.dataField}
                                aria-pressed={(column.toggle) ? "true" : "false"}
                                onClick={() => customFunkcija(column) }
                            >
                                {column.text}
                        </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
            }

            else{
                return <div className="btn-group btn-group-toggle mt-4" data-toggle="buttons">
                {columns
                    .filter(data => data.dataField !== "sakriveno")
                    .map(column => ({
                    ...column,
                    toggle: toggles[column.dataField]
                    }))
                    .map((column) => (
                        <button
                            key = {column.dataField}
                            type="button"
                            className={ ` ${column.toggle ? 'btn btn-success active' : 'btn btn-danger'}` }
                            data-toggle="button"
                            label={column.text}
                            id={column.dataField}
                            aria-pressed={(column.toggle) ? "true" : "false"}
                            onClick={() => customFunkcija(column) }
                        >
                            {column.text}
                        </button>
                    ))}
                </div>
            }
        };



        const beforeSaveCell = async (oldValue, newValue, row, column) => {
            let data

            let editedColumn = this.state.stupci.filter(data => data.name === column.dataField)

            let indexForMapping
             this.props.reportErrorList.map((data, index) => {
                if( data["ID KORISNIKA"] === row["ID KORISNIKA"] && data["INDENTIFIKATOR NARUDŽBE"] === row["INDENTIFIKATOR NARUDŽBE"]){
                    indexForMapping = index
                }
                return null
            })

            if(editedColumn.length > 0 && editedColumn[0].value === this.props.reportErrorList[indexForMapping].Error && oldValue !== newValue){
                data = {
                    index: indexForMapping,
                    variable: "Error",
                    value: false
                }

                this.props.mapState("MAP_REPORTS_ERROR_LIST_CHANGE", data)

                data = {
                    index: indexForMapping,
                    variable: column.dataField,
                    value: newValue
                }
                this.props.mapState("MAP_REPORTS_ERROR_LIST_CHANGE", data)
            }
        }

        const MySearch = (props) => {
            let input;
            const handleClick = () => {
              props.onSearch(input.value);
            };
            return (
                <input
                  className="form-control"
                  ref={ n => input = n }
                  type="text"
                  onChange= { handleClick }
                />
            );
        };

        const sizePerPageRenderer = ({
            options,
            currSizePerPage,
            onSizePerPageChange
          }) => (
            <div className="btn-group" role="group">
              {
                options.map((option) => {
                  const isSelect = currSizePerPage === `${option.page}`;
                  return (
                    <button
                      key={ option.text }
                      type="button"
                      onClick={ () => onSizePerPageChange(option.page) }

                      className={ `btn ${isSelect ? 'btn-secondary' : 'btn-warning'}` }
                    >
                      { option.text }
                    </button>
                  );
                })
              }
            </div>
          );

          const options = {
            sizePerPageRenderer,
            sizePerPageList: [
                { text: "10", value: 10},
                { text: "20", value: 20},
                { text: "50", value: 50},
                { text: "100", value: 100},
                { text: "200", value: 200}
            ]
        };

        // OK OK OK
        const selectRow = {
            mode: 'checkbox',
            //hideSelectColumn: false,
            //clickToSelect: true,
            clickToEdit: true,
            nonSelectable: this.props.reportErrorList.filter((data) => data.Error !== false).map((data) => data.index),
            nonSelectableClasses: 'my-class',
            onSelect: (row, isSelected) => {
                let dataRedux = {
                    index: row.index,
                    variable: "selected",
                    value: isSelected
                }
                this.props.mapState("MAP_REPORTS_ERROR_LIST_CHANGE", dataRedux)
            },
            onSelectAll: (isSelect, rows, e) => {
                rows.map((data, index) => {
                    let dataRedux = {
                        index: data.index,
                        variable: "selected",
                        value: isSelect
                    }
                    this.props.mapState("MAP_REPORTS_ERROR_LIST_CHANGE", dataRedux)
                    return null
                })
            }
        }

        // This function is used to make and log any changes to the table
        const cellEdit = cellEditFactory({
           mode: 'click',
           blurToSave: true,
           beforeSaveCell
        })

	return(
            <>
            {this.props.loading ||this.state.loading ?
                <Loader/>
            :
            !this.state.uploadingReport ?
                this.state.errorsExist ?
                <>
                <ToolkitProvider
                    keyField="id"
                    data={this.props.reportErrorList}
                    columns={columns}
                    columnToggle
                    //prikaziSakrij = {this.prikaziSakrij}
                    bodyStyle={{wordBreak: 'break-word'} }
                    search ={ { className: "searchList" } }
                >
                    {(props) => (
                    <>
                        <Row>
                            <Col sm={12} lg={12}>
                                <CustomToggleList {...props.columnToggleProps} />
                            </Col>
                        </Row>
                        <br/>
                        <Row>
                            <Col sm={12} lg={3} className="mb-4">
                                <MySearch { ...props.searchProps } />
                            </Col>

                            <Col sm={1}>
                                <Button
                                    variant="danger"
                                    className="w-auto float-right"
                                    onClick={() =>this.CorrectedErrors()}
                                >
                                    {t('Send')}
                                </Button>
                            </Col>
                        </Row>
                        <br/>
                        <Row>
                            <div className="table-responsive" >
                                <BootstrapTable {...props.baseProps}
                                    keyField="index"
                                    hover
                                    pagination= { paginationFactory(options) }
                                    columns={ columns }
                                    selectRow={ selectRow }
                                    // filter={ filterFactory()  }
                                    cellEdit={ cellEdit }
                                />
                            </div>
                        </Row>
                    </>
                    )}
                </ToolkitProvider>
                </>
                :
                <h1 className="text-center mt-4 color-green"> {t('All records uploaded!')}</h1>
            :
            <Row className="justify-content-center mt-6">
                <div className="error-list.progress-bar">
                    <CircularProgressbar
                        value={this.props.percentage}
                        text={`${this.props.percentage}%`}
                        styles={buildStyles({
                            // Rotation of path and trail, in number of turns (0-1)
                            //: 0.25,

                            // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                            strokeLinecap: 'butt',

                            // Text size
                            textSize: '16px',

                            // How long animation takes to go from one percentage to another, in seconds
                            pathTransitionDuration: 0.5,

                            // Can specify path transition in more detail, or remove it entirely
                            // pathTransition: 'none',

                            // Colors
                            pathColor: themeColor,
                            textColor: themeColor,
                            trailColor: pathColor,
                            backgroundColor: '#000',
                        })}
                    />
                </div>

                {this.props.reportsError > 0 ?
                    <h1 className="color-red p-6 text-center"> Errors: {this.props.reportsError} </h1>
                : null }

                {this.props.percentage === 100 ?
                    this.props.reportsError > 0 ?
                        <Row className="justify-content-center">
                                <Button
                                    variant="danger"
                                    className="w-auto"
                                    onClick={() =>this.CorrectErrors()}
                                >
                                    {t('Correct errors')}
                                </Button>
                        </Row>
                    :
                        null
                : null }

                {this.props.percentage === 100 ?
                        <Row>
                            <div
                                onClick={() =>this.ResetAll()}
                                className="btn btn-default col-2 mb-2"
                            >
                                <BsBackspaceFill size={30} />
                                <strong> {t('Back')} </strong>
                            </div>
                        </Row>
                : null}
            </Row>
            }
          </>
        )}
}

const mapStateToProps = state => {
  return {
        reportErrorList: state.report.reportErrorList,
        themeColor: state.user.user_web_properties.settings.themeColor,
        providerId: state.user.provider_uuid,
        percentage: state.report.percentage,
        sizePerPage: state.report.sizePerPage,
        activePage: state.report.activePage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    mapState: (type, data) => dispatch({ type: type, data: data}),
    API: (type, data) => dispatch({ type: type, data: data})
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(ReportErrorList));
